import { render, staticRenderFns } from "./ExtendWorkplaceAssignationForm.vue?vue&type=template&id=1e5d9b3d&scoped=true"
import script from "./ExtendWorkplaceAssignationForm.vue?vue&type=script&lang=js"
export * from "./ExtendWorkplaceAssignationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5d9b3d",
  null
  
)

export default component.exports